module.exports = __webpack_public_path__ + "images/nest-64954bee0da8dbcd9a9c66240156a6f2.jpg";